let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1QHKh")).then(() => parcelRequire('l1BWk'));